import React from 'react';
import Chat from '../pages/chat/index';
import Shopping from '../pages/shopping';
import Tools from '../pages/tools';
import Admin from '../pages/admin';

import { PageAds } from '../pages/ads/index';
import { Report } from '../pages/report';
import glotaTranslationService from '../services/glota-translation.service';

import { BotLineLight } from '@poli-digital/react';

/**
 * Caso queria que a rota apareça no sidebar, adicionar sidebarName
 */
/*const spa_api_state = (state) => {

};*/

// Traduções usando tradução síncrona local
const getRoutes = () => {
  const homeText = glotaTranslationService.translateSync('spa.navigation.home');
  const chatText = glotaTranslationService.translateSync('spa.navigation.chat');
  const crmText = glotaTranslationService.translateSync('spa.navigation.crm');
  const automationText = glotaTranslationService.translateSync(
    'spa.navigation.automation'
  );
  const reportText = glotaTranslationService.translateSync(
    'spa.navigation.report'
  );
  const administrationText = glotaTranslationService.translateSync(
    'spa.navigation.administration'
  );
  const settingsText = glotaTranslationService.translateSync(
    'spa.navigation.settings'
  );
  const payText = glotaTranslationService.translateSync('spa.navigation.pay');
  const adsText = glotaTranslationService.translateSync('spa.navigation.ads');

  return [
    {
      path: '/home',
      title: homeText,
      exact: true,
      sidebarName: homeText,
      icon: 'poli-icon pi-home-line',
      content: '',
      showPwa: true,
      tag: 'home',
    },
    {
      path: '/chat',
      title: chatText,
      sidebarName: chatText,
      icon: 'poli-icon pi-message-line',
      content: Chat,
      showPwa: true,
      tag: 'chat',
    },
    {
      path: '/crm/index',
      title: crmText,
      sidebarName: crmText,
      icon: 'poli-icon pi-filter-line',
      content: '',
      tag: 'crm',
      showPwa: true,
    },
    {
      path: '/automation',
      title: automationText,
      sidebarName: automationText,
      icon: <BotLineLight />,
      content: '',
      tag: 'automation',
      showPwa: true,
    },

    {
      path: '/relatorio',
      title: reportText,
      sidebarName: reportText,
      icon: 'poli-icon pi-chart-line',
      content: '',
      showPwa: false,
      tag: 'report',
    },
    {
      path: '/admin',
      title: administrationText,
      sidebarName: administrationText,
      subitens: true,
      icon: 'poli-icon pi-company-line',
      content: Admin,
      showPwa: true,
      needAdmin: true,
      tag: 'admin',
    },
    {
      path: '/settings',
      title: settingsText,
      sidebarName: settingsText,
      icon: 'poli-icon pi-setting-line',
      content: '',
      showPwa: false,
      tag: 'tools',
    },
    {
      path: '/shopping',
      title: payText,
      sidebarName: payText,
      subitens: true,
      icon: 'poli-icon pi-poli-pay-fill',
      content: Shopping,
      showPwa: true,
      tag: 'pay',
    },
    {
      path: '/tools',
      title: settingsText,
      sidebarName: settingsText,
      subitens: true,
      icon: 'poli-icon pi-tool-line',
      content: Tools,
      tag: 'tools',
    },
    {
      path: '/ads',
      title: adsText,
      sidebarName: adsText,
      subitens: true,
      icon: 'poli-icon pi-alerts-line',
      content: PageAds,
      tag: 'ads',
    },
  ];
};

const routes = getRoutes();

export default routes;
